import * as React from 'react';
import { useEffect, useImperativeHandle } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { message, Modal, List, Divider, Button, Popconfirm, Collapse } from 'antd';
import SpinLoader from 'components/Loader/SpinLoader';

import { getUserIntegrationType } from 'utils';
import { getGoogleClassForUser, synCourseForGoogleClassRoom } from 'store/googleClassRoom/thunks';
import { useUserClasses } from 'store/userClasses/selectors';
import { handleListClassSyncStatus, handleUpdateClassSyncStatus } from 'store/classes/thunks';
import dayjs from "dayjs";
import { handleListUserClasses, handleRemoveUserClasses } from 'store/userClasses/thunks';
import { handleGetCanvasCourseByUser, handleSyncCanvasClass } from 'store/canvas/thunks';
import { handleFetchSchoologyCourses, handleSyncSchoologyClass } from 'store/schoology/thunks';
import { handleListCleverClasses, handleSyncCleverClass } from 'store/clever/thunks';
import { handleListClasslinkSections, handleSyncClasslinkClass } from 'store/classlink/thunks';
import { useCurrentUser } from 'store/users/selectors';
import SentryWrap from 'components/Sentry';
const ButtonClass = styled.button`
    border-radius: 25.5px;
    background: linear-gradient(135deg, #582F81 0%, #7B68EE 100%);
    min-height: 44px;
    min-width: 200px;
    padding: 8px 20px;
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
    border: none;
    outline: none;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(88, 47, 129, 0.3);
    
    &:hover {
        background: linear-gradient(135deg, #7B68EE 0%, #582F81 100%) !important;
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(88, 47, 129, 0.4);
    }
    
    &:active {
        transform: translateY(0);
    }
    
    @media (max-width: 1200px) {
        min-width: 180px;
        min-height: 42px;
        font-size: 15px;
    }
    
    @media (max-width: 768px) {
        min-width: 160px;
        font-size: 14px;
        min-height: 40px;
        padding: 6px 16px;
    }
    
    @media (max-width: 480px) {
        min-width: 140px;
        font-size: 13px;
        min-height: 38px;
        padding: 5px 12px;
    }
`;
export const CourseSync = React.forwardRef(({  }, ref) => {
  const [visible, setVisible] = React.useState(false);
  const [isloading, setIsLoading] = React.useState(false);
  const dispatch = useDispatch();
  const [class_data, setClassData] = React.useState([]);
  const [syncStatus, setSyncStatus] = React.useState([]);
  const userClasses = useUserClasses();
  const currentUser = useCurrentUser();
  const user_type = React.useMemo(() => currentUser && currentUser.id ? getUserIntegrationType(currentUser) : "", [currentUser]);
  
  // Expose methods to parent component via ref
  useImperativeHandle(ref, () => ({
    openModal: () => setVisible(true),
    closeModal: () => setVisible(false),
    isModalOpen: () => visible
  })); 
  const listOfClassesSynced = React.useMemo(() => {
    if (!userClasses || !userClasses.length) return [];
    if (user_type == 'google') {
      const synced = class_data.filter(x => userClasses.some(uc => uc.googleId === x.id)).map(x => ({
        ...x,
        classInfo: userClasses.find(uc => uc.googleId === x.id)
      }));
      // Sort: active (archive === false or falsy) first, then archived
      return synced.sort((a, b) => {
        const aActive = a.classInfo?.archived === false || a.classInfo?.archived === undefined;
        const bActive = b.classInfo?.archived === false || b.classInfo?.archived === undefined;
        if (aActive === bActive) return 0;
        return aActive ? -1 : 1;
      });
      
    } else if (user_type == 'canvas') {
      const synced = class_data.filter(x => userClasses.some(uc => uc.canvas_id == x.id && uc.canvas_course_id == x.course_id)).map(x => ({
        ...x,
        classInfo: userClasses.find(uc => uc.canvas_id == x.id && uc.canvas_course_id == x.course_id)
      }));
      return synced.sort((a, b) => {
        const aActive = a.classInfo?.archived === false || a.classInfo?.archived === undefined;
        const bActive = b.classInfo?.archived === false || b.classInfo?.archived === undefined;
        if (aActive === bActive) return 0;
        return aActive ? -1 : 1;
      });
    } else if (user_type == 'schoology') {
      // console.log("class_data", class_data,userClasses);
      const synced = class_data.filter(x => userClasses.some(uc => uc.sectionId == x.id)).map(x => ({
        ...x,
        classInfo: userClasses.find(uc => uc.sectionId == x.id) || {}
      }));
      // console.log("synced", synced);
      return synced.sort((a, b) => {
        const aActive = a.classInfo?.archived === false || a.classInfo?.archived === undefined;
        const bActive = b.classInfo?.archived === false || b.classInfo?.archived === undefined;
        if (aActive === bActive) return 0;
        return aActive ? -1 : 1;
      });
          } else if (user_type == 'clever') {
        const synced = class_data.filter(x => userClasses.some(uc => uc.cleverId == x.id)).map(x => ({
          ...x,
          classInfo: userClasses.find(uc => uc.cleverId == x.id) || {}
        }));
        return synced.sort((a, b) => {
          const aActive = a.classInfo?.archived === false || a.classInfo?.archived === undefined;
          const bActive = b.classInfo?.archived === false || b.classInfo?.archived === undefined;
          if (aActive === bActive) return 0;
          return aActive ? -1 : 1;
        });
      } else if (user_type == 'classlink') {
        const synced = class_data.filter(x => userClasses.some(uc => uc.classlinkid == x.sourcedId)).map(x => ({
          ...x,
          classInfo: userClasses.find(uc => uc.classlinkid == x.sourcedId) || {}
        }));
        return synced.sort((a, b) => {
          const aActive = a.classInfo?.archived === false || a.classInfo?.archived === undefined;
          const bActive = b.classInfo?.archived === false || b.classInfo?.archived === undefined;
          if (aActive === bActive) return 0;
          return aActive ? -1 : 1;
        });
      }
      return [];
  }, [userClasses, class_data]);
  const listOfUnsyncData = React.useMemo(() => {
    if (user_type == 'google') {
      return class_data.filter(x => !listOfClassesSynced.some(uc => uc.id == x.id) && !syncStatus.some(s => s.section_id == x.id&& s.archive));
    } else if (user_type == 'canvas') {
      return class_data.filter(x => !listOfClassesSynced.some(uc => uc.id == x.id && uc.course_id == x.course_id) && !syncStatus.some(s => s.section_id == x.id  && s.course_id == x.course_id && s.archive));
    } else if (user_type == 'schoology') {
      return class_data.filter(x => !listOfClassesSynced.some(uc => uc.id == x.id ) && !syncStatus.some(s => s.section_id == x.id && s.archive));
    } else if (user_type == 'clever') {
      return class_data.filter(x => !listOfClassesSynced.some(uc => uc.id == x.id) && !syncStatus.some(s => s.section_id == x.id && s.archive));
    } else if (user_type == 'classlink') {
      return class_data.filter(x => !listOfClassesSynced.some(uc => uc.sourcedId == x.sourcedId) && !syncStatus.some(s => s.section_id == x.sourcedId && s.archive));
    }
    return [];
  }, [class_data, syncStatus]);
  const archivedClasses = React.useMemo(() => {
    if (user_type == 'google') {
      return class_data.filter(x => syncStatus.some(s => s.section_id == x.id && s.archive));
    } else if (user_type == 'canvas') {
      return class_data.filter(x => syncStatus.some(s => s.section_id == x.id && s.course_id == x.course_id && s.archive));
    } else if (user_type == 'schoology') {
      return class_data.filter(x => syncStatus.some(s => s.section_id == x.id && s.archive));
    } else if (user_type == 'clever') {
      return class_data.filter(x => syncStatus.some(s => s.section_id == x.id && s.archive));
    } else if (user_type == 'classlink') {
      return class_data.filter(x => syncStatus.some(s => s.section_id == x.sourcedId  && s.archive));
    }
    return [];
  }, [class_data, syncStatus]);
  // const updateSyncStatusOfExistingClass = React.useCallback(async() => {
  //   if (user_type == 'google') {
  //     const google_classes = (userClasses||[]).map(x => {
  //       const course = class_data.find(y => y.id == x.googleId)
  //       if (course) {
  //         return ({
  //           course_id: course.id,   // parent course id
  //           section_id: course.id,      // section id if exists
  //           user_id: currentUser.id,
  //           synced: true,
  //           archive: false
  //         })
  //       }
  //       return null
  //     }).filter(x => x)
  //     if (google_classes.length) {
  //       await handleUpdateClassSyncStatus(google_classes)
  //     }
  //   } else if(user_type == 'clever'){
  //   const clever_classes = userClasses.map(x => {
  //     const course = class_data.find(y => y.id == x.cleverId)
  //     if(course){
  //     return({
  //       section_id: course.id,
  //       course_id: course.course,
  //       archive: false,
  //       user_id: currentUser.id,
  //       synced: true
  //       })
  //     }
  //     return null
  //   }).filter(x => x)
  //   if(clever_classes.length){
  //     await handleUpdateClassSyncStatus(clever_classes)
  //   }
  //  } else if(user_type == 'canvas'){
  //   const canvas_classes = userClasses.map(x => {
  //     const course = class_data.find(y => y.id == x.canvas_id)
  //     if(course){
  //       return({
  //         section_id: course.id,
  //         course_id: course.course_id,
  //         archive: false,
  //         user_id: currentUser.id,
  //         synced: true
  //       })
  //     }
  //     return null
  //   }).filter(x => x)
  //   console.log("canvas_classes",canvas_classes)
  //   if(canvas_classes.length){
  //     await handleUpdateClassSyncStatus(canvas_classes)
  //   }
  //  } else if(user_type == 'schoology'){
  //   const schoology_classes = userClasses.map(x => {
  //     const course = class_data.find(y => y.id == x.schoologyid)
  //     if(course){
  //       return({
  //         section_id: course.id,
  //         course_id: course.course_id,
  //         archive: false,
  //         user_id: currentUser.id,
  //         synced: true
  //       })
  //     }
  //     return null
  //   }).filter(x => x)
  //   if(schoology_classes.length){
  //     await handleUpdateClassSyncStatus(schoology_classes)
  //   }
  //  }
  //  await fetchSyncStatus()
  // }, [currentUser,class_data]);

      
  const fetchGoogleClassroomSync = React.useCallback(async() => {
      const class_data = await getGoogleClassForUser(currentUser.googleId)
      if(class_data && class_data.success &&class_data.data?.length) {
          setClassData(class_data.data);
      }else{
        message.error("Failed to fetch Google Classroom classes.");
      }
  }, [currentUser]);
  const fetchCleverClassesForUser = React.useCallback(async() => {''
    const clever_courses = await handleListCleverClasses(currentUser.cleverId)
    if(clever_courses && clever_courses.success) {
      setClassData(clever_courses.data);
    } else {
      message.error("Failed to fetch Clever classes.");
    }
  }, [currentUser]);
  const fetchClasslinkClassesForUser = React.useCallback(async() => {
    const classlink_sections = await handleListClasslinkSections(currentUser.classlinkid, currentUser.classlinkTenantId)
    if(classlink_sections && classlink_sections.success) {
      setClassData(classlink_sections.data);
    } else {
      message.error("Failed to fetch Classlink classes.");
    }
  }, [currentUser]); 
  const fetchCanvasClassesForUser = React.useCallback(async() => {
    const canvas_course = await handleGetCanvasCourseByUser(currentUser.canvas_id, currentUser.canvas_auth_id, currentUser.role === "teacher");
    if(canvas_course && canvas_course.success && canvas_course.data?.length) {
      setClassData(canvas_course.data);
    } else {
      message.error("Failed to fetch Canvas classes.");
    }
  }, [currentUser]);
  const fetchSchoologyClassesForUser = React.useCallback(async () => {
    const schoology_courses = await handleFetchSchoologyCourses(currentUser.schoologyid)
    if (schoology_courses && schoology_courses.success) {
      setClassData(schoology_courses.data);
    } else {
      message.error("Failed to fetch Schoology classes.");
    }
  }, [currentUser]);
  
  const fetchSyncStatus = React.useCallback(async() => {
    const sync_status = await handleListClassSyncStatus(currentUser.id);
    if(sync_status && sync_status.success && sync_status.data?.length) {
        setSyncStatus(sync_status.data);
    } else if(sync_status && sync_status.error) {
        message.error("Failed to fetch sync status.");
    }
  }, [currentUser]);

  async function fetchUserSyncStatus() {
      setIsLoading(true);
      try {
          // Simulate an API call to check sync status
          if(user_type=== "google") {
              await fetchGoogleClassroomSync();
          } else if(user_type === "clever") {
              await fetchCleverClassesForUser();
          } else if(user_type === "classlink") {
              await fetchClasslinkClassesForUser();
          } else if(user_type === "canvas") {
              await fetchCanvasClassesForUser();
          } else if(user_type === "schoology") {
              await fetchSchoologyClassesForUser();
          }  
          await fetchSyncStatus()
      } catch (error) {
          console.error('Error fetching user sync status:', error);
      } finally {
          setIsLoading(false);
      }

  }

  useEffect(() => {
    if (currentUser && currentUser.id && visible) {
      fetchUserSyncStatus()
    }
  }, [dispatch, currentUser, visible,user_type]);
  if(!user_type) return null;
  // console.log("CourseSync component rendered with user_type:", user_type,class_data,syncStatus,userClasses,listOfClassesSynced);

const handleSync = async (course) => {
  setIsLoading(true);
  try {
    if (user_type === "google") {
      await handleUpdateClassSyncStatus({
        course_id: course.id,   // parent course id
        section_id: course.id,      // section id if exists
        user_id: currentUser.id,
        synced: true,
        archive: false
      })
      const dt = await dispatch(synCourseForGoogleClassRoom(currentUser.id, currentUser.googleId, course));

      if (dt?.success) {
        message.success("Class synced successfully.");
        await fetchSyncStatus();
      } else {
        message.error("Failed to sync class.");
      }
    } else if (user_type === "canvas") {
      await handleUpdateClassSyncStatus({
        course_id: course.course_id || course.id,   // parent course id
        section_id: course.id,      // section id if exists
        user_id: currentUser.id,
        synced: true,
        archive: false
        })
      const dt = await dispatch(handleSyncCanvasClass(currentUser.canvas_id, currentUser.canvas_auth_id, course,currentUser));
      if (dt?.success) {
        message.success("Canvas class synced successfully.");
        await fetchSyncStatus();
      } else {
        message.error("Failed to sync class.");
      }
    } else if (user_type === "schoology") {
      await handleUpdateClassSyncStatus({
        section_id: course.id,
        course_id: course.course_id,
        archive: false,
        user_id: currentUser.id,
        synced: true
      })
      const dt = await dispatch(handleSyncSchoologyClass(currentUser.schoologyid, course,currentUser));
      if (dt?.success) {
        message.success("Schoology class synced successfully.");
        await fetchSyncStatus();
      } else {
        message.error("Failed to sync class.");
      }
    } else if (user_type === "clever") {
      await handleUpdateClassSyncStatus({
        section_id: course.id,
        course_id: course.course,
        archive: false,
        user_id: currentUser.id,
        synced: true
      })
      const dt = await dispatch(handleSyncCleverClass(currentUser.cleverId, course,currentUser));
      if (dt?.success) {
        message.success("Clever class synced successfully.");
        await fetchSyncStatus();
      } else {
        message.error("Failed to sync class.");
      }
    } else if (user_type === "classlink") {
      await handleUpdateClassSyncStatus({
        section_id: course.sourcedId,
        archive: false,
        user_id: currentUser.id,
        synced: true,
        course_id: course.sourcedId
      })
      const dt = await dispatch(handleSyncClasslinkClass(currentUser.classlinkid, currentUser.classlinkTenantId, course,currentUser));
      if (dt?.success) {
        message.success("Class archived successfully.");
        await fetchSyncStatus();
      } else {
        message.error("Failed to sync class.");
      }
    }
    await fetchSyncStatus() 
  } catch (error) {
    console.error("Error during sync:", error);
    message.error("Failed to sync class.");
  } finally {
    setIsLoading(false);
  }
};


  const handleArchive = async (course) => {
    try {
      setIsLoading(true);
      if (user_type === "google") {
        if (course.classInfo && course.classInfo.id && course.classInfo.userclass && course.classInfo.userclass.id) {
          await dispatch(handleRemoveUserClasses(course.classInfo.userclass.id));
          await dispatch(handleListUserClasses(currentUser.id));
        }
        const syncState = await handleUpdateClassSyncStatus({
          section_id: course.id,
          archive: true,
          user_id: currentUser.id,
          synced: false,
          course_id: course.id
        })
        if (syncState && syncState.success) {
          message.success("Class archived successfully.");
          await fetchSyncStatus();
        } else {
          message.error("Failed to unarchive class.");
        }
      } else if (user_type === "canvas") {
        if (course.classInfo && course.classInfo.id && course.classInfo.userclass && course.classInfo.userclass.id) {
          await dispatch(handleRemoveUserClasses(course.classInfo.userclass.id));
          await dispatch(handleListUserClasses(currentUser.id));
        }
        const syncState = await handleUpdateClassSyncStatus({
          section_id: course.id,
          archive: true,
          user_id: currentUser.id,
          synced: false,
          course_id: course.course_id || course.id
        })
        if (syncState && syncState.success) {
          message.success("Canvas class archived successfully.");
          await fetchSyncStatus();
        } else {
          message.error("Failed to archive Canvas class.");
        }
      } else if (user_type === "schoology") {
        if (course.classInfo && course.classInfo.id && course.classInfo.userclass && course.classInfo.userclass.id) {
          await dispatch(handleRemoveUserClasses(course.classInfo.userclass.id));
          await dispatch(handleListUserClasses(currentUser.id));
        }
        const syncState = await handleUpdateClassSyncStatus({
          section_id: course.id,
          archive: true,
          user_id: currentUser.id,
          synced: false,
          course_id: course.course_id
        })
        if (syncState && syncState.success) {
          message.success("Schoology class archived successfully.");
          await fetchSyncStatus();
        } else {
          message.error("Failed to archive Schoology class.");
        }
      } else if (user_type === "clever") {
        if (course.classInfo && course.classInfo.id && course.classInfo.userclass && course.classInfo.userclass.id) {
          await dispatch(handleRemoveUserClasses(course.classInfo.userclass.id));
          await dispatch(handleListUserClasses(currentUser.id));
        }
        const syncState = await handleUpdateClassSyncStatus({
          section_id: course.id,
          archive: true,
          user_id: currentUser.id,
          synced: false,
          course_id: course.course
        })
        if (syncState && syncState.success) {
          message.success("Clever class archived successfully.");
          await fetchSyncStatus();
        } else {
          message.error("Failed to archive Clever class.");
        }
      } else if (user_type === "classlink") {
        if (course.classInfo && course.classInfo.id && course.classInfo.userclass && course.classInfo.userclass.id) {
          await dispatch(handleRemoveUserClasses(course.classInfo.userclass.id));
          await dispatch(handleListUserClasses(currentUser.id));
        }
      const syncState = await handleUpdateClassSyncStatus({
        section_id: course.sourcedId,
        archive: true,
        user_id: currentUser.id,
        synced: false,
        course_id: course.sourcedId
      })
      if (syncState && syncState.success) {
        message.success("Class archived successfully.");
        await fetchSyncStatus();
      } else {
        message.error("Failed to archive class.");
      }
    }
    } catch (error) {

    } finally {
      setIsLoading(false);
    }
  };

 
  const renderClassList = (title, data, actions) => (
    <>
      <Divider orientation="left" style={{
        fontSize: '18px',
        fontWeight: '600',
        color: '#333',
        margin: '24px 0 16px 0',
        '@media (max-width: 1200px)': {
          fontSize: '17px',
          margin: '20px 0 14px 0'
        },
        '@media (max-width: 768px)': {
          fontSize: '16px',
          margin: '18px 0 12px 0'
        },
        '@media (max-width: 480px)': {
          fontSize: '15px',
          margin: '16px 0 10px 0'
        }
      }}>{title}</Divider>
      <List
        bordered
        dataSource={data}
        size="default"
        style={{
          borderRadius: '8px',
          overflow: 'hidden',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          '@media (max-width: 1200px)': {
            fontSize: '14px'
          },
          '@media (max-width: 768px)': {
            fontSize: '13px'
          },
          '@media (max-width: 480px)': {
            fontSize: '12px'
          }
        }}
        renderItem={item => {
          // Compose title and description for Meta
          let metaTitle = '';
          let statusTag = null;
          
          // Handle different user types
          if (user_type === 'schoology') {
            // Schoology specific handling
            metaTitle = item.course_title || item.section_title || item.id || '';
            if (item.section_title && item.course_title && item.section_title !== item.course_title) {
              metaTitle = `${item.course_title} - ${item.section_title}`;
            }
            
            // Status based on active field and synced status
            if (item.classInfo?.archived === true) {
              statusTag = <span style={{ color: '#ff4d4f', marginLeft: 6 }}>(Archived)</span>;
            } else if (item.classInfo?.archived === false) {
              statusTag = <span style={{ color: '#52c41a', marginLeft: 6 }}>(Active)</span>;
            }
          } else if (user_type === 'clever') {
            // Clever specific handling
            metaTitle = item.name || item.id || '';
            
            // Status based on archived status
            if (item.classInfo?.archived === true) {
              statusTag = <span style={{ color: '#ff4d4f', marginLeft: 6 }}>(Archived)</span>;
            } else if (item.classInfo?.archived === false) {
              statusTag = <span style={{ color: '#52c41a', marginLeft: 6 }}>(Active)</span>;
            }
          } else if (user_type === 'classlink') {
            // Classlink specific handling
            metaTitle = item.title || item.displayName || item.sourcedId || '';
            
            // Status based on archived status and status field
            if (item.classInfo?.archived === true) {
              statusTag = <span style={{ color: '#ff4d4f', marginLeft: 6 }}>(Archived)</span>;
            } else if (item.classInfo?.archived === false && item.status === 'active') {
              statusTag = <span style={{ color: '#52c41a', marginLeft: 6 }}>(Active)</span>;
            } else if (item.status === 'inactive') {
              statusTag = <span style={{ color: '#faad14', marginLeft: 6 }}>(Inactive)</span>;
            }
          } else {
            // Existing logic for other user types
            metaTitle = item.name || item.title || item.id || '';
            if (item.classInfo?.archived === true) {
              statusTag = <span style={{ color: '#ff4d4f', marginLeft: 6 }}>(Archived)</span>;
            } else if (item.classInfo?.archived === false) {
              statusTag = <span style={{ color: '#52c41a', marginLeft: 6 }}>(Active)</span>;
            }
          }
          
          const descriptionParts = [];
          
          // Schoology specific description
          if (user_type === 'schoology') {
            if (item.course_code) descriptionParts.push(`Course Code: ${item.course_code}`);
            if (item.section_code) descriptionParts.push(`Section: ${item.section_code}`);
            if (item.subject_area) descriptionParts.push(`Subject: ${item.subject_area}`);
            if (item.grade_level_range_start && item.grade_level_range_end) {
              descriptionParts.push(`Grades: ${item.grade_level_range_start}-${item.grade_level_range_end}`);
            } else if (item.grade_level_range_start) {
              descriptionParts.push(`Grade: ${item.grade_level_range_start}`);
            }
            if (item.access_code) descriptionParts.push(`Access Code: ${item.access_code}`);
          } else if (user_type === 'clever') {
            // Clever specific description
            if (item.subject) descriptionParts.push(`Subject: ${item.subject.charAt(0).toUpperCase() + item.subject.slice(1)}`);
            if (item.grade) descriptionParts.push(`Grade: ${item.grade}`);
            if (item.period) descriptionParts.push(`Period: ${item.period}`);
            if (item.section_number) descriptionParts.push(`Section: ${item.section_number}`);
            if (item.sis_id) descriptionParts.push(`SIS ID: ${item.sis_id}`);
            if (item.created) descriptionParts.push(`Created: ${dayjs(item.created).format('MMM D, YYYY')}`);
            if (item.students && item.students.length > 0) descriptionParts.push(`Students: ${item.students.length}`);
            if (item.teachers && item.teachers.length > 0) descriptionParts.push(`Teachers: ${item.teachers.length}`);
          } else if (user_type === 'classlink') {
            // Classlink specific description
            if (item.classCode) descriptionParts.push(`Class Code: ${item.classCode}`);
            if (item.grades && item.grades.length > 0) descriptionParts.push(`Grades: ${item.grades.join(', ')}`);
            if (item.subjects && item.subjects.length > 0) descriptionParts.push(`Subjects: ${item.subjects.join(', ')}`);
            if (item.periods && item.periods.length > 0) descriptionParts.push(`Periods: ${item.periods.join(', ')}`);
            if (item.courseDetails?.courseCode) descriptionParts.push(`Course Code: ${item.courseDetails.courseCode}`);
            if (item.dateLastModified) descriptionParts.push(`Modified: ${dayjs(item.dateLastModified).format('MMM D, YYYY')}`);
            if (item.location) descriptionParts.push(`Location: ${item.location}`);
            if (item.status) descriptionParts.push(`Status: ${item.status.charAt(0).toUpperCase() + item.status.slice(1)}`);
          } else {
            if (item.descriptionHeading) descriptionParts.push(`Description: ${item.descriptionHeading}`);
            if (item.creationTime && user_type === 'google') descriptionParts.push(`Created: ${dayjs(item.creationTime).format('MMM D, YYYY')}`);
            if (user_type === 'canvas' && item.course_info?.name) descriptionParts.push(`Course Name: ${item.course_info.name}`);
            if (user_type === 'canvas' && item.created_at) descriptionParts.push(`Created: ${dayjs(item.created_at).format('MMM D, YYYY')}`);
          }
          
          const metaDescription = descriptionParts.length > 0 ? descriptionParts.join(' | ') : undefined;
          
          let coTeachersDisplay = null;
          if (user_type === 'canvas' && item.teachers && item.teachers.length > 0) {
            const coTeachers = item.teachers.filter(t => t.userId != currentUser.canvas_id);
            if (coTeachers.length > 0) {
              coTeachersDisplay = (
                <div style={{ marginTop: 4 }}>
                  <strong style={{ color: '#7B68EE' }}>Co-Teachers:</strong> {coTeachers.map(t => t.name).join(', ')}
                </div>
              );
            }
          }
          
          if (user_type === 'schoology' && item.teachers && item.teachers.length > 0) {
            const coTeachers = item.teachers.filter(t => t.id != currentUser.schoologyid);
            if (coTeachers.length > 0) {
              coTeachersDisplay = (
                <div style={{ marginTop: 4 }}>
                  <strong style={{ color: '#7B68EE' }}>Co-Teachers:</strong> {coTeachers.map(t => `${t.firstName} ${t.lastName}`).join(', ')}
                </div>
              );
            }
          }
          
          if (user_type === 'clever' && item.teachers && item.teachers.length > 0) {
            const coTeachers = item.teachers.filter(t => t.id != currentUser.cleverId);
            if (coTeachers.length > 0) {
              coTeachersDisplay = (
                <div style={{ marginTop: 4 }}>
                  <strong style={{ color: '#7B68EE' }}>Co-Teachers:</strong> {coTeachers.map(t => `${t.firstName} ${t.lastName}`).join(', ')}
                </div>
              );
            }
          }
          
          if (user_type === 'classlink' && item.teachers && item.teachers.length > 0) {
            const coTeachers = item.teachers.filter(t => t.id != currentUser.classlinkid);
            if (coTeachers.length > 0) {
              coTeachersDisplay = (
                <div style={{ marginTop: 4 }}>
                  <strong style={{ color: '#7B68EE' }}>Co-Teachers:</strong> {coTeachers.map(t => `${t.firstName} ${t.lastName}`).join(', ')}
                </div>
              );
            }
          }
          
          if (user_type === 'google' && item.teachers && item.teachers.length > 0) {
            const coTeachers = item.teachers.filter(t => t.id != currentUser.googleId);
            if (coTeachers.length > 0) {
              coTeachersDisplay = (
                <div style={{ marginTop: 4 }}>
                  <strong style={{ color: '#7B68EE' }}>Co-Teachers:</strong> {coTeachers.map(t => `${t.firstName} ${t.lastName}`).join(', ')}
                </div>
              );
            }
          }
          
          return (
            <List.Item
              actions={actions(item).map(({ label, onConfirm, confirmMessage }, index) => (
                <Popconfirm
                  key={index}
                  title={confirmMessage}
                  onConfirm={() => onConfirm(item)}
                  okText="Yes"
                  cancelText="No"
                >
                  {label === 'Decline' ? (
                    <Button 
                      size="middle"
                      style={{ 
                        background: 'linear-gradient(135deg, #ff4d4f 0%, #ff7875 100%)',
                        color: '#fff', 
                        border: 'none',
                        borderRadius: '6px',
                        fontWeight: '500',
                        boxShadow: '0 2px 8px rgba(255, 77, 79, 0.3)',
                        transition: 'all 0.3s ease',
                        '@media (max-width: 1200px)': {
                          fontSize: '13px',
                          padding: '6px 12px',
                          height: '32px'
                        },
                        '@media (max-width: 768px)': {
                          fontSize: '12px',
                          padding: '4px 10px',
                          height: '30px'
                        },
                        '@media (max-width: 480px)': {
                          fontSize: '11px',
                          padding: '3px 8px',
                          height: '28px'
                        }
                      }}
                    >
                      {label}
                    </Button>
                  ) : label === 'Accept' ? (
                    <Button 
                      size="middle"
                      style={{ 
                        background: 'linear-gradient(135deg, #52c41a 0%, #73d13d 100%)',
                        color: '#fff', 
                        border: 'none',
                        borderRadius: '6px',
                        fontWeight: '500',
                        boxShadow: '0 2px 8px rgba(82, 196, 26, 0.3)',
                        transition: 'all 0.3s ease',
                        '@media (max-width: 1200px)': {
                          fontSize: '13px',
                          padding: '6px 12px',
                          height: '32px'
                        },
                        '@media (max-width: 768px)': {
                          fontSize: '12px',
                          padding: '4px 10px',
                          height: '30px'
                        },
                        '@media (max-width: 480px)': {
                          fontSize: '11px',
                          padding: '3px 8px',
                          height: '28px'
                        }
                      }}
                    >
                      {label}
                    </Button>
                  ) : (
                    <Button 
                      size="middle"
                      type="link"
                      style={{
                        color: '#1890ff',
                        fontWeight: '500',
                        '@media (max-width: 1200px)': {
                          fontSize: '13px',
                          padding: '6px 12px'
                        },
                        '@media (max-width: 768px)': {
                          fontSize: '12px',
                          padding: '4px 10px'
                        },
                        '@media (max-width: 480px)': {
                          fontSize: '11px',
                          padding: '3px 8px'
                        }
                      }}
                    >
                      {label}
                    </Button>
                  )}
                </Popconfirm>
              ))}
            >
              <List.Item.Meta
                title={<>{metaTitle} {statusTag}</>}
                description={
                  <>
                    {metaDescription}
                    {coTeachersDisplay}
                  </>
                }
              />
            </List.Item>
          );
        }}
      />
    </>
  );
//  console.log("CourseSync component rendered with user_type:", user_type,  listOfClassesSynced);
  return (
    <SentryWrap>
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '20px',
      '@media (max-width: 768px)': {
        gap: '16px'
      },
      '@media (max-width: 480px)': {
        gap: '12px'
      }
    }}>
    <SpinLoader dataloader={isloading} />
      <ButtonClass onClick={() => setVisible(true)}>Sync courses</ButtonClass>
      <Modal
        open={visible}
        onCancel={() => setVisible(false)}
        footer={null}
        closable={true}
        width="90vw"
        style={{ 
          top: '5vh',
          padding: 0,
          maxWidth: '1200px'
        }}
        styles={{ 
          body: { 
            height: '90vh',
            padding: 0,
            borderRadius: '8px',
            overflow: 'hidden'
          }, 
          mask: { backgroundColor: 'rgba(0,0,0,0.6)' },
          wrapper: {
            '@media (max-width: 768px)': {
              padding: '10px'
            },
            '@media (max-width: 480px)': {
              padding: '5px'
            }
          }
        }}
        centered={true}
      >
        <div style={{ 
          width: '100%', 
          height: '90vh', 
          background: '#fff', 
          padding: '24px',
          overflowY: 'auto',
          borderRadius: '8px',
          '@media (max-width: 1200px)': {
            padding: '20px'
          },
          '@media (max-width: 768px)': {
            padding: '16px',
            height: '85vh'
          },
          '@media (max-width: 480px)': {
            padding: '12px',
            height: '80vh'
          }
        }}>
          {listOfUnsyncData.length>0?renderClassList('Un-synced Classes', listOfUnsyncData, (item) => [
            { label: 'Accept', onConfirm: handleSync, confirmMessage: 'Are you sure you want to sync this class?' },
            { label: 'Decline', onConfirm: handleArchive, confirmMessage: 'Are you sure you want to decline this class?' }
          ]):null}
          {renderClassList('Synced Classes', listOfClassesSynced, (item) => [
            { label: 'Archive', onConfirm: handleArchive, confirmMessage: 'Are you sure you want to archive this class?' }
          ])}
          <Collapse defaultActiveKey={[]} style={{ 
            marginTop: 24,
            '@media (max-width: 1200px)': {
              marginTop: 20
            },
            '@media (max-width: 768px)': {
              marginTop: 16
            },
            '@media (max-width: 480px)': {
              marginTop: 12
            }
          }}>
            <Collapse.Panel 
              header={
                <span style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: '#333',
                  '@media (max-width: 1200px)': {
                    fontSize: '15px'
                  },
                  '@media (max-width: 768px)': {
                    fontSize: '14px'
                  },
                  '@media (max-width: 480px)': {
                    fontSize: '13px'
                  }
                }}>
                  Archived Classes
                  {archivedClasses.length > 0 && (
                    <span style={{
                      background: 'linear-gradient(135deg, #ff4d4f 0%, #ff7875 100%)',
                      color: '#fff',
                      borderRadius: '12px',
                      padding: '3px 10px',
                      marginLeft: 10,
                      fontSize: 12,
                      fontWeight: '600',
                      verticalAlign: 'middle',
                      display: 'inline-block',
                      boxShadow: '0 2px 6px rgba(255, 77, 79, 0.3)',
                      '@media (max-width: 1200px)': {
                        fontSize: '11px',
                        padding: '2px 8px',
                        marginLeft: 8
                      },
                      '@media (max-width: 768px)': {
                        fontSize: '10px',
                        padding: '2px 6px',
                        marginLeft: 6
                      },
                      '@media (max-width: 480px)': {
                        fontSize: '9px',
                        padding: '1px 5px',
                        marginLeft: 5
                      }
                    }}>{archivedClasses.length}</span>
                  )}
                </span>
              }
              key="archived"
            >
              {renderClassList('Archived Classes', archivedClasses, (item) => [
                { label: 'Un-archive', onConfirm: handleSync, confirmMessage: 'Are you sure you want to unarchive this class? It will be synced to your classes.' },
              ])}
            </Collapse.Panel>
          </Collapse>
        </div>
      </Modal>
    </div>
    </SentryWrap>
  ); 
});